import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var PhotoIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M39.25 8.11011H10.1C8.43707 8.11011 6.84229 8.77075 5.66644 9.94653C4.4906 11.1223 3.83002 12.717 3.83002 14.3799V34.73C3.83002 36.3928 4.4906 37.9878 5.66644 39.1636C6.84229 40.3394 8.43707 41 10.1 41H39.25C40.9129 41 42.5077 40.3394 43.6835 39.1636C44.8594 37.9878 45.52 36.3928 45.52 34.73V14.3799C45.52 12.717 44.8594 11.1223 43.6835 9.94653C42.5077 8.77075 40.9129 8.11011 39.25 8.11011ZM43.02 34.73C43.02 35.7297 42.6228 36.6887 41.9158 37.3958C41.2087 38.1028 40.2499 38.5 39.25 38.5H10.1C9.10089 38.4973 8.14355 38.0994 7.43713 37.3928C6.73071 36.6863 6.33264 35.729 6.33002 34.73V14.3799C6.33264 13.3809 6.73071 12.4236 7.43713 11.717C8.14355 11.0105 9.10089 10.6128 10.1 10.6101H39.25C40.2499 10.6101 41.2087 11.0071 41.9158 11.7141C42.6228 12.4211 43.02 13.3801 43.02 14.3799V34.73ZM12.97 21.1201C15.2896 21.1201 17.17 19.2576 17.17 16.96C17.17 14.6624 15.2896 12.8 12.97 12.8C10.6504 12.8 8.77002 14.6624 8.77002 16.96C8.77002 19.2576 10.6504 21.1201 12.97 21.1201ZM15.85 25.23L19.44 28.8L31.28 16.97L40.58 26.55V34.0701C40.58 34.6641 40.344 35.2336 39.9239 35.6538C39.5038 36.074 38.9341 36.3101 38.34 36.3101H11.01C10.416 36.3101 9.84619 36.074 9.42609 35.6538C9.00598 35.2336 8.77002 34.6641 8.77002 34.0701V32.23L15.85 25.23Z"
  }));
});
PhotoIcon.displayName = 'PhotoIcon';
PhotoIcon.defaultProps = {
  'aria-label': 'Photo'
};
export default PhotoIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/PhotoIcon/index.js
// module id = 1915
// module chunks = 12